import { useContext } from 'react';
import { AppDataContext, type AppDataContextValue } from '@/app/providers/AppDataProvider';

/** Current gameweek and the signed-in manager's standings. */
export function useAppData(): AppDataContextValue {
  const context = useContext(AppDataContext);

  if (!context) {
    throw new Error('useAppData must be used within an <AppDataProvider>.');
  }

  return context;
}
